/** Browser-safe configuration. Missing values are reported, never guessed. */
export const env = {
  apiBase: (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/$/, "") ?? "",
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? "",
  supabaseKey: (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined) ?? "",
};

export const authConfigured = Boolean(env.supabaseUrl && env.supabaseKey);
export const apiConfigured = Boolean(env.apiBase);
